import * as React from "react"

const SvgDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m12.005 13.324 3.903-3.906a.95.95 0 0 1 .701-.275q.426 0 .7.275a.95.95 0 0 1 .276.701.95.95 0 0 1-.275.701l-4.604 4.607q-.15.15-.326.213a1.1 1.1 0 0 1-.375.063q-.2 0-.375-.063a.9.9 0 0 1-.326-.213L6.7 10.82a.95.95 0 0 1-.275-.7.95.95 0 0 1 .275-.702.95.95 0 0 1 .7-.275q.427 0 .702.275z" />
  </svg>
)
export default SvgDown
